export default {
  provinces: [],

  cities: [],

  internalUnits: [],

  roles: [],

  tariffTypes: [],

  vehicles: [],

  smsTemplates: [],

  settingDropdown: {},

  companies: [],

  fiscalYears: [],

  accountInfos: [],

  subscribers: [],

  activityGroups: [],

  waterBillPeriods: [],

  meterReadings: [],

  automationTypes: [],

  serviceTypes: [],

  billboards: [],

  billboardRequestStatuses: [],

  vehicleTypes: [],

  automations: [],

  personTypes: [],

  tariffs: [],

  accounts: [],

  projects: [],

  paymentProcesses: [],

  setting: [],
};
